export default "__VITE_ASSET__7TPDfSXe__"